import { ActionReducerMap, MetaReducer } from '@ngrx/store'
import * as fromAccountState from '../../account/store/reducers/account.reducer'
import * as fromInternationalDataState from './international-data.reducer'
import * as fromInitialConfigState from '../../shared/app-config/store/reducers/initial-config.reducer'

export interface State {
  [fromAccountState.accountFeatureKey]: fromAccountState.AccountState
  [fromInternationalDataState.internationalDataFeatureKey]: fromInternationalDataState.InternationalDataState
  [fromInitialConfigState.initialConfigFeatureKey]: fromInitialConfigState.InitialConfigState
}

export const reducers: ActionReducerMap<State> = {
  [fromAccountState.accountFeatureKey]: fromAccountState.reducer,
  [fromInternationalDataState.internationalDataFeatureKey]: fromInternationalDataState.reducer,
  [fromInitialConfigState.initialConfigFeatureKey]: fromInitialConfigState.reducer,
}

export const metaReducers: MetaReducer<State>[] = []
